import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './GradeSelector.css';

const GRADES = [
  { value: 0, label: 'Kindergarten' },
  { value: 1, label: '1st Grade' },
  { value: 2, label: '2nd Grade' },
  { value: 3, label: '3rd Grade' },
  { value: 4, label: '4th Grade' },
  { value: 5, label: '5th Grade' },
  { value: 6, label: '6th Grade' },
  { value: 7, label: '7th Grade' },
  { value: 8, label: '8th Grade' },
  { value: 9, label: '9th Grade' },
  { value: 10, label: '10th Grade' },
  { value: 11, label: '11th Grade' },
  { value: 12, label: '12th Grade' },
];

export default function GradeSelector() {
  const [selectedGrade, setSelectedGrade] = useState<number | null>(null);
  const [schoolType, setSchoolType] = useState<'site-based' | 'virtual'>('site-based');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const { user, updateGrade } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async () => {
    if (selectedGrade === null) {
      setError('Please select your grade level');
      return;
    }

    setIsSubmitting(true);
    setError(null);

    try {
      await updateGrade(selectedGrade, schoolType);
      navigate('/', { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to save grade selection');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="grade-selector-container">
      <div className="grade-selector-card">
        <div className="selector-header">
          <h1>Select Your Grade</h1>
          <p>
            Hi {user?.name?.split(' ')[0]}! We couldn't automatically detect your grade level.
            Please select it below to continue.
          </p>
        </div>

        {error && (
          <div className="selector-error">
            {error}
          </div>
        )}

        <div className="selector-section">
          <label className="section-label">What grade are you in?</label>
          <div className="grade-grid">
            {GRADES.map((grade) => (
              <button
                key={grade.value}
                className={`grade-option ${selectedGrade === grade.value ? 'selected' : ''}`}
                onClick={() => setSelectedGrade(grade.value)}
              >
                {grade.label}
              </button>
            ))}
          </div>
        </div>

        <div className="selector-section">
          <label className="section-label">What type of school do you attend?</label>
          <div className="school-type-options">
            <button
              className={`school-type-option ${schoolType === 'site-based' ? 'selected' : ''}`}
              onClick={() => setSchoolType('site-based')}
            >
              <span className="option-emoji">🏫</span>
              <span className="option-label">In-Person School</span>
              <span className="option-description">I attend school in-person</span>
            </button>
            <button
              className={`school-type-option ${schoolType === 'virtual' ? 'selected' : ''}`}
              onClick={() => setSchoolType('virtual')}
            >
              <span className="option-emoji">💻</span>
              <span className="option-label">Virtual School</span>
              <span className="option-description">I attend school online</span>
            </button>
          </div>
        </div>

        <button
          className="submit-btn"
          onClick={handleSubmit}
          disabled={selectedGrade === null || isSubmitting}
        >
          {isSubmitting ? 'Saving...' : 'Continue to Survey'}
        </button>
      </div>
    </div>
  );
}
